import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionContractInfo, TypeActionContractInfo, } from "../actionContractInfo";
export var epicMarketContractSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.Skip), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.SkipContract,
            props: {
                amount: Long.fromValue(action.amount || 0),
                contractId: action.contractId,
                farmId: state.playerBase.base.baseId,
                itemId: IdResource.Gold,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var inventoryItems = { amount: res.amount, typeId: res.itemId };
            return from([
                actionInventoryInfoRemoveResource([inventoryItems]),
                actionContractInfo(res),
            ]);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicMarketContractSkip.ts
// module id = 2002
// module chunks = 3